import { showBanner } from './../template/template.js'
import './style.min.css'
import { gsap } from 'gsap'

/* -------- START GOOGLE SHEETS -------- */
const GoogleSheetsAPIURL =
    'https://sheets.googleapis.com/v4/spreadsheets/12yLnX1dQG9Bh7QzmCOwWuXf_4IonCPsaUS2IaAfoYEQ/values/Processed!A:C?key=AIzaSyCAbZoRrxcMfvj50hB_XZ1qfDclIhx3CsE'

// Send GET request
function httpGetAsync(url, callback) {
    var xmlHttp = new XMLHttpRequest()
    xmlHttp.onreadystatechange = function () {
        // Check if request is done
        if (xmlHttp.readyState == 4) {
            // Check if request is successful
            if (xmlHttp.status == 200) {
                callback(JSON.parse(xmlHttp.response))
            }
            // Wait until the request is done before checking for error
            else {
                showBanner("We couldn't fetch the data :(", 'Une erreur est survenue :(', 0)
            }
        }
    }
    xmlHttp.open('GET', url, true)
    xmlHttp.send(null)
}

// Send GET request to Google Sheets API
httpGetAsync(GoogleSheetsAPIURL, (response) => {
    // Array of all members [[Seed, Name, Title], ...]
    let members = response.values
    let currentSeedName = null
    let currentSeedSection = null

    for (let memberData of members) {
        let memberSeed = memberData[0]
        let memberName = memberData[1]
        let memberTitle = memberData[2]
        // Ignore empty rows
        if (!memberSeed) continue
        // See if member is part of current seed
        if (currentSeedName != memberSeed) {
            currentSeedName = memberSeed
            currentSeedSection = document.querySelector(`#${memberSeed} .people`)
        }
        // Make sure seed exists in DOM
        if (!currentSeedSection) {
            console.warn(`"${memberSeed}" does not exist...`)
            continue
        }
        // Create person element
        let personElement = document.createElement('div')
        personElement.classList.add('person')
        personElement.innerHTML = `<div class="transparent-circle"></div><div class="name-container"><div class="name">${memberName}</div><div class="title">${
            memberTitle ? memberTitle : ''
        }</div></div>`
        currentSeedSection.appendChild(personElement)
    }
})
/* -------- END GOOGLE SHEETS -------- */

/* -------- START ANIMATION -------- */
const expandablePeople = document.querySelectorAll('.expandable')

for (let person of expandablePeople) {
    let circleBg = person.querySelector('.circle-bg')
    let squareBg = person.querySelector('.square-bg')
    let profilePic = person.querySelector('img')
    let ul = person.querySelector('ul')
    let text = person.querySelectorAll('.description, li')
    // Link the elements together for later animation
    person.circleBg = circleBg
    person.squareBg = squareBg
    person.profilePic = profilePic
    person.ul = ul
    person.text = text

    person.addEventListener('focusin', () => {
        expand(person)
    })
    person.addEventListener('focusout', () => {
        collapse(person)
    })
    person.addEventListener('mouseenter', () => {
        for (let p of expandablePeople) {
            if (p !== person && p === document.activeElement) {
                collapse(p)
                // Remove focus
                p.blur()
            }
        }
        expand(person)
    })
    person.addEventListener('mouseleave', () => {
        if (person !== document.activeElement) {
            collapse(person)
        }
    })
}

// If two animations conflict, the shorter one should have overwrite: true
function expand(person) {
    gsap.to(person.circleBg, {
        y: '3em',
        duration: 0.5,
        delay: 0.2,
        overwrite: true,
    })
    gsap.to(person.squareBg, {
        clipPath: 'circle(70% at 50% 50%)',
        pointerEvents: 'all',
        duration: 1,
    })
    gsap.to(person.profilePic, {
        clipPath: 'circle(70% at 50% 50%)',
        duration: 1,
        ease: 'linear',
    })
    gsap.to(person.profilePic, {
        y: '-1.5em',
        duration: 0.6,
        onStart: () => {
            person.circleBg.style.boxShadow = '0 0.1em 0.3em #00000000'
        },
        onComplete: () => {
            person.profilePic.style.boxShadow = '0 0.1em 0.3em #00000040'
            person.squareBg.style.boxShadow = '0 0.1em 0.3em #00000040'
        },
    })
    if (person.ul) {
        gsap.set(person.ul, {
            pointerEvents: 'all',
        })
    }
    if (person.text) {
        gsap.to(person.text, {
            opacity: 0.9,
            pointerEvents: 'all',
            duration: 0.5,
            delay: 0.4,
        })
    }
}

function collapse(person) {
    gsap.to(person.circleBg, {
        y: 0,
        duration: 0.8,
    })
    gsap.to(person.squareBg, {
        clipPath: 'circle(15% at 18% 14%)',
        pointerEvents: 'none',
        duration: 0.8,
        overwrite: true,
    })
    gsap.to(person.profilePic, {
        clipPath: 'circle(50% at 50% 50%)',
        duration: 1,
        onStart: () => {
            person.profilePic.style.boxShadow = '0 0.1em 0.3em #00000000'
            person.squareBg.style.boxShadow = '0 0.1em 0.3em #00000000'
        },
    })
    gsap.to(person.profilePic, {
        y: 0,
        duration: 0.5,
        overwrite: 'auto',
        onComplete: () => {
            person.circleBg.style.boxShadow = '0 0.1em 0.3em #00000040'
        },
    })
    if (person.ul) {
        gsap.set(person.ul, {
            pointerEvents: 'none',
        })
    }
    if (person.text) {
        gsap.to(person.text, {
            opacity: 0,
            pointerEvents: 'none',
            duration: 0.3,
            overwrite: true,
        })
    }
}
/* -------- END ANIMATION -------- */
